module.exports = new __parcel__URL__("sendActive.0b890cde.svg").toString();